import { IAuthState } from '../../interfaces';

const authState: IAuthState = {
	auth0Error: undefined,
	receivingAuth0Authentication: false,
	requestingRemoveServerSideCookie: false,
	requestingSetServerSideCookie: false,
	unauthorized: false
};

export default authState;
